import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M12.5 4H6C5.30964 4 4.75 4.5596 4.75 5.25V10.541V12.6662C4.75 13.1282 5.32306 13.343 5.6268 12.9948L7.76724 10.541H12.5C13.1904 10.541 13.75 9.9813 13.75 9.291V5.25C13.75 4.5596 13.1904 4 12.5 4Z" />
		<Path d="M12 13H18.5C19.1904 13 19.75 13.5596 19.75 14.25V19.541V21.6662C19.75 22.1282 19.1769 22.343 18.8732 21.9948L16.7328 19.541H12C11.3096 19.541 10.75 18.9813 10.75 18.291V14.25C10.75 13.5596 11.3096 13 12 13Z" />
	</SVG>
);
